import Dialog from '@storeblocks/dialog';
import { useTranslations } from '@storebrand-digital/fms-translations-react';
import { useEffect, useState } from 'react';
import auth from '../../../utils/auth';
import useAuthTimeout from './useAuthTimeout';

const AuthTimeoutHandler = () => {
  const [forceClose, setForceClose] = useState(false);
  const { thresholdReached, expired, handleRefresh } = useAuthTimeout();

  const { getText } = useTranslations();
  const textPrefix = `authTimeout.${expired ? 'expired' : 'warning'}`;

  // If modal is force closed, show modal again when token is expired
  useEffect(() => {
    setForceClose(false);
  }, [expired]);

  const handleClose = () => {
    if (expired) {
      auth.logout();
    }
    setForceClose(true);
  };

  return (
    <Dialog
      open={(thresholdReached || expired) && !forceClose}
      onConfirm={handleRefresh}
      onClose={handleClose}
      confirmButtonLabel={getText(`${textPrefix}.button`)}
      cancelButtonLabel="Lukk"
      heading={getText(`${textPrefix}.header`)}
      trigger={undefined}
    >
      {getText(`${textPrefix}.content`)}
    </Dialog>
  );
};

export default AuthTimeoutHandler;
